import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: mocking-mike
 * id AF474E3E-6D21-4C03-9D59-F784287C35AC
 * name lock-percent-open-outline
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lock-percent-open-outline.svg
 * tags
 */
export const LockPercentOpenOutlineIcon = createSvgIcon(<><path d="M9.5 11C10.3 11 11 11.7 11 12.5S10.3 14 9.5 14 8 13.3 8 12.5 8.7 11 9.5 11M14.5 19C13.7 19 13 18.3 13 17.5S13.7 16 14.5 16 16 16.7 16 17.5 15.3 19 14.5 19M9.2 19.2L7.8 17.8L14.9 10.7L16.3 12.1L9.2 19.2M18 8H17V6C17 3.2 14.8 1 12 1S7 3.2 7 6H9C9 4.3 10.3 3 12 3S15 4.3 15 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8M18 20H6V10H18V20Z" /></>, 'LockPercentOpenOutlineIcon');
export default LockPercentOpenOutlineIcon